// extracted by mini-css-extract-plugin
export default {"link":"GuardedLink_link__M+xaX"};